import React, { useState } from 'react';
import DateRangeCalendar from './Calendar';
import { format } from 'date-fns';
import { Button } from './ui/Button';
import { remittanceService } from '../services/remittance';
import toast from 'react-hot-toast';

export const RemittanceDownloadModal: React.FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      toast.error('Please select a date range');
      return;
    }

    setLoading(true);
    try {
      const response = await remittanceService.getRemittanceFiles({
        fromDate: format(startDate, 'yyyy-MM-dd'),
        toDate: format(endDate, 'yyyy-MM-dd'),
        fileType: 'inward',
      });
      
      if (response && response.data && response.data.length > 0 && response.data[0].fileUrl) {
        window.open(response.data[0].fileUrl, '_blank');
        toast.success('Download started');
        onClose();
      } else {
        toast.error('No remittance data found for the selected range');
      }
    } catch (err) {
      toast.error('Failed to fetch data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-2 text-gray-900">Download Data</h2>
      <p className="text-sm text-gray-500 mb-6">
        Select a date range to download the inward remittance data.
      </p>

      <div className="flex justify-center mb-8">
        <DateRangeCalendar
          startDate={startDate}
          endDate={endDate}
          onChange={(start, end) => {
            setStartDate(start);
            setEndDate(end);
          }}
        />
      </div>

      <div className="flex justify-end gap-3 pt-6 border-t border-gray-100">
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleDownload} disabled={loading} className="px-8">
          {loading ? 'Fetching...' : 'Download'}
        </Button>
      </div>
    </div>
  );
};
